itsoftApp.createModule("ani", ["ajax"],   function() {
    var boxClass = (".js-ajax-box");
    var box = $(boxClass);
    var content = $(".js-ajax-content");
    var animateClass = ("is-animate");

    if (box.hasClass("no-ajax")){
        content.removeClass(animateClass);
    }
});